import { Injectable } from '@angular/core';
import { PortfolioItem } from './portfolio-item'

@Injectable()
export class PortfolioService {
  private static currentItem: PortfolioItem;
  private  portfolioItems: PortfolioItem[] = [
        new PortfolioItem(0,
          'NECTAR FLORAL + EVENT DESIGN',
          'Events',
          'As a startup company, Nectar Floral' +
          ' + Event Design needed help with the beginnings of their web presence: in this case,' +
          ' a website that matched the look and feel of their business.' +
          'We worked with Nectar to design and develop a custom website based on their logo design and look/feel of the company.',
          'Creative Digital',
          'august 15/2016',
          'Web design',
          'Creative Digital',
          [
            '../../assets/portfolio/worksDetails/one/oneCover.jpg',
            '../../assets/portfolio/worksDetails/one/two.png'
          ]),
          new PortfolioItem( 1,
            'OIL SALES CONSULTING',
            'Business Consulting',
            'Oil Sales Consulting launched a new website for the brand new business and needed optimized content and ongoing blogging to create and enhance its search presence. In addition, ongoing content pieces like whitepapers and landing pages are needed.We’re happy to have an ongoing partnership with the team at OSC. We started by creating and optimizing the content on the Oil Sales Consulting website. From there, we create regular blogposts as well as content pieces for their oil industry clients.',
            'Marina Lytkina',
            'october 2/2016',
            'seo optimisation',
            'CREATIVE DIGITAL',
            [
              '../../assets/portfolio/worksDetails/two/twoCover.jpg',
              '../../assets/portfolio/worksDetails/two/two.jpg'
            ]),
          new PortfolioItem( 2,
            'LIBRA GROUP',
            'Web Development',
            'Tubby’s Ice Cream was redesigning and relaunching their website and wanted to improve their internet presence.' +
            'We worked with the development team from DG Media Arts to use Local Search Engine Optimization for Tubby’s.',
            'Eugine Mofje',
            'january 23/2017',
            'seo',
            'CREATIVE DIGITAL',
            [
              '../../assets/portfolio/worksDetails/four/fourCover.jpg',
              '../../assets/portfolio/worksDetails/three/two.jpg'
            ]),
          new PortfolioItem( 3,
            'Tubby’s ice cream',
            'Maine ice cream shop',
            'Tubby’s Ice Cream was redesigning and relaunching their website and wanted to improve their internet presence.' +
            'We worked with the development team from DG Media Arts to use Local Search Engine Optimization for Tubby’s.',
            'Eugine Mofje',
            'january 23/2017',
            'seo',
            'CREATIVE DIGITAL',
            [
              '../../assets/portfolio/worksDetails/three/threeCover.jpg',
              '../../assets/portfolio/worksDetails/four/two.jpg'
            ]),
            new PortfolioItem( 4,
              'Aidband',
              'Custom E-Commerce Site for Customizable Wristbands',
              'AIDBAND needed an e-commerce solution where their customers could choose a band of their choice, then easily design and create customized buttons. The team also wanted to be able to integrate social media and content into their strategy, where customers could share bands they created for an even more inspirational experience.' +
              ' We took their website to the next level by helping them with content and leading the way with their blog and social media campaign.',
              'CREATIVE DIGITAL',
              'may 12/2016',
              'WEB DEVELOPMENT/DESIGN',
              'CREATIVE DIGITAL',
              [
                '../../assets/portfolio/worksDetails/seven/seven.jpg',
                '../../assets/portfolio/worksDetails/five/two.jpg'
              ]),
            new PortfolioItem( 5,
              'SOLEIL SEWING STUDIO',
              'Sewing and Design Studio',
              'Soleil Sewing Studio is currently showcasing their new leather handbags, so they asked us to design a site. We built an E-Commerce solution where customers can order the beautiful bags utilizing all of the popular payment processes. We also provided them with a Facebook presence, where Carole can connect with her clients, and all the necessary photography for their site.',
              'CREATIVE DIGITAL',
              'DECEMBER 17/2016',
              'WEB DEVELOPMENT/DESIGN',
              'CREATIVE DIGITAL',
              [
                '../../assets/portfolio/worksDetails/five/five.jpg',
                '../../assets/portfolio/worksDetails/five/two.jpg'
              ]),
            new PortfolioItem( 6,
              'AQUASCAPE DESIGN & CONSTRUCTION',
              'A Business Portfolio Web Solution',
              'We were approached by Aquascape Design & Construction to provide a web solution to display a business portfolio and promote services offered.' +
              'We built a sleek, responsive business portfolio site for Twitchell Aquascape Design & Construction to display their beautiful landscape creations as well as interact with potential customers via a blog.',
              'CREATIVE DIGITAL',
              '14 november/2016',
              'WEB DEVELOPMENT/DESIGN',
              'CREATIVE DIGITAL',
              [
                '../../assets/portfolio/worksDetails/six/six.jpg',
                '../../assets/portfolio/worksDetails/six/two.jpg'
              ]),
            new PortfolioItem( 7,
              'TAX DEBT ASSISTANCE',
              'Tax Experts',
              'Tax Debt Assistance was looking to improve the search engine visibility of several landing pages they’d created.' +
              'We optimized and copyedited the landing pages and provided ongoing reporting for Tax Debt Assistance.',
              'CREATIVE DIGITAL',
              '16 OCTOBER/2016',
              'SEO',
              'CREATIVE DIGITAL',
              [
                '../../assets/portfolio/worksDetails/eight/eight.jpg',
                '../../assets/portfolio/worksDetails/seven/two.jpg'
              ]),
            new PortfolioItem( 8,
              'SLOW FOOD FIRST COAST',
              'Custom Website Design',
              'Slow Food First Coast had a website, but it was no longer accommodating their needs. Between the ability to add new pages as well as new events, the organization had simply outgrown its old solution.' +
              'We started by cleaning up the navigation and structure of the website; as the needs of the nonprofit have changed since the original website was built. Then, we designed and built SFFC a WordPress website so that they are able to update pages whenever they would like.',
              'CREATIVE DIGITAL',
              '14 FEBRUARY/2017',
              'WEB DEVELOPMENT/DESIGN',
              'me',
              [
                '../../assets/portfolio/worksDetails/nine/nine.jpg',
                '../../assets/portfolio/worksDetails/eight/two.jpg'
              ]),
            new PortfolioItem( 9,
              'OSC DESIGN',
              'Design Agency',
              'OSC Web Design was re-launching their website and wanted to update content and re-optimize for the search engines, as it’s a great time to do a refresh during any type of re-launch. We’ve been working co-creatively with OSC Web Design for many years now and we were excited to help re-write and re-optimize the copy for their website. We also put together landing page and whitepaper copy to convert OSC web visitors.',
              'CREATIVE DIGITAL',
              '27 NOVEMBER/2016',
              'SEO',
              'OSC DESIGN',
              [
                '../../assets/portfolio/worksDetails/ten/watch.jpg',
                '../../assets/portfolio/worksDetails/nine/two.jpg'
              ]),


        ];


  constructor() { }

  setPortfolioItem(id:number){
      PortfolioService.currentItem = this.portfolioItems[id];
  }

  getPortfolioItem() {
    return  PortfolioService.currentItem;
  }

  getItemById(id: number){
    return this.portfolioItems[id];
  }

  setNext(){
   let id = PortfolioService.currentItem.id;
   if (id <= this.portfolioItems.length - 2){
   this.setPortfolioItem(id + 1);
     } else {
     this.setPortfolioItem(0);
   }
  }

  setPrev(){
    let id = PortfolioService.currentItem.id;
    if (id <= 0){
      this.setPortfolioItem(this.portfolioItems.length - 1);
    } else {
      this.setPortfolioItem(id - 1);
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/portfolio/portfolio.service.ts